
const config = {
  types: [],
  modifiers: [
    { title: 'default', isDefault: true },
    'inverse',
    'image',
    'video',
    'inverse',
    'horizontal'
  ],
  states: []
}
const cards = {
  retails: {
    title: 'retails',
    name: 'CardRetail',
  },
  product: {
    title: 'product',
    name: 'CardProduct',
  },
  institutional: {
    title: 'institutional',
    name: 'CardInstitutional',
  }
}


export default function useCard(keys: string[]) {
  function getCardName() {

    const currentCard = keys.find((it) => Object
      .keys(cards).includes(it))

    return cards[currentCard] ?? cards['institutional']

  }

  return {
    currentCard: getCardName(),
    config
  }
}
